import { Panel } from "./shared";

const TARGETS = [
  { v: 0, label: "Max" },
  { v: 100, label: "100KB" },
  { v: 200, label: "200KB" },
  { v: 500, label: "500KB" },
  { v: 1000, label: "1MB" },
  { v: 2000, label: "2MB" },
];

export const CompressPanel = ({ targetKb, onChange, activePicker }) => (
  <Panel>
    <div className="grid grid-cols-3 sm:grid-cols-6 gap-1 p-1 bg-page border border-hairline rounded-lg" data-testid="compress-target-picker">
      {TARGETS.map((t) => (
        <button key={t.v} data-testid={`compress-target-${t.v}`} onClick={() => onChange(t.v)}
          className={`py-2 min-h-[44px] rounded-full font-mono text-xs transition-colors duration-300 ${targetKb === t.v ? activePicker : "text-fog hover:text-ink"}`}>
          {t.label}
        </button>
      ))}
    </div>
    <p className="font-mono text-[10px] text-mist mt-2" data-testid="compress-target-hint">
      {targetKb ? `Target ${targetKb >= 1000 ? `${targetKb / 1000}MB` : `${targetKb}KB`} — images are reduced step by step until the file fits, or as close as the content allows.` : "Maximum savings — text stays selectable and searchable."}
    </p>
  </Panel>
);
